// extracted by mini-css-extract-plugin
module.exports = {"icon":"SvgIcon_icon__3rxkk"};